import { Spinner } from "react-bootstrap";

export default function Loading({ isToHidden }) {

    return (
        <div hidden={isToHidden}
            style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 1000,
            }}
        >
            <Spinner animation="border" role="status" />
        </div>
    );
}